import { render, staticRenderFns } from "./ChartCard.vue?vue&type=template&id=673302fe"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"
import style0 from "./ChartCard.vue?vue&type=style&index=0&id=673302fe&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673302fe')) {
      api.createRecord('673302fe', component.options)
    } else {
      api.reload('673302fe', component.options)
    }
    module.hot.accept("./ChartCard.vue?vue&type=template&id=673302fe", function () {
      api.rerender('673302fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/material/ChartCard.vue"
export default component.exports